import React, { useState } from 'react';
import strings from '../../../../constants/strings.constants';
import Typo from '../../../atom/Typo';
import colors from '../../../../constants/colors.constants';
import Checkbox from '../../../atom/Checkbox';
import { ReactComponent as ArrowRight } from '../../../../assets/arrow-right2.svg';
import { CustomerPartnerTermsDto } from '../../../../apis/terms';

export interface TermsListProps {
  termsList: CustomerPartnerTermsDto[];
  onTermsChange?: (isValid: boolean) => void;
  onTermsDetailClick?: (terms: CustomerPartnerTermsDto) => void;
}

function TermsList(props: TermsListProps) {
  const { termsList, onTermsChange, onTermsDetailClick } = props;

  const [checkedTerms, setCheckedTerms] = useState<Record<number, boolean>>({});
  const [allTermsAgreement, setAllTermsAgreement] = useState(false);

  const handleTermsClick = (id: number) => {
    const updatedCheckedTerms = {
      ...checkedTerms,
      [id]: !checkedTerms[id],
    };
    const allTermsAgreed =
      Object.values(updatedCheckedTerms).filter((value) => value).length ===
      termsList.length;

    setCheckedTerms(updatedCheckedTerms);
    setAllTermsAgreement(allTermsAgreed);

    if (onTermsChange) {
      const essentialTermsIds = termsList
        .filter(({ optionable }) => !optionable)
        .map(({ currentTermsHistory }) => currentTermsHistory.id);

      let isValid = true;
      essentialTermsIds.forEach((id) => {
        if (!updatedCheckedTerms[id]) {
          isValid = false;
        }
      });
      onTermsChange(isValid);
    }
  };

  const handleAllAgreementClick = () => {
    const updatedCheckedTerms: Record<number, boolean> = {};
    termsList.forEach(({ currentTermsHistory }) => {
      updatedCheckedTerms[currentTermsHistory.id] = !allTermsAgreement;
    });
    setCheckedTerms(updatedCheckedTerms);
    setAllTermsAgreement(!allTermsAgreement);

    if (onTermsChange) {
      const essentialTermsIds = termsList
        .filter(({ optionable }) => !optionable)
        .map(({ currentTermsHistory }) => currentTermsHistory.id);

      let isValid = true;
      essentialTermsIds.forEach((id) => {
        if (!updatedCheckedTerms[id]) {
          isValid = false;
        }
      });
      onTermsChange(isValid);
    }
  };

  const renderTermsItem = (terms: CustomerPartnerTermsDto) => {
    const { currentTermsHistory, optionable, title } = terms;

    let termsPrefix = strings.termsEssential;
    if (optionable) {
      termsPrefix = strings.termsOptional;
    }

    return (
      <div className="flex gap-1" key={currentTermsHistory.id}>
        <div
          className="flex gap-1 items-start min-h-[40px] grow cursor-pointer"
          onClick={() => {
            handleTermsClick(currentTermsHistory.id);
          }}
        >
          <div className="mr-2 grow-0">
            <Checkbox
              id={`${currentTermsHistory.id}`}
              checked={checkedTerms[currentTermsHistory.id]}
            />
          </div>
          <div className="flex items-start flex-wrap gap-1 mt-[1px]">
            <Typo
              type="r-16"
              color={colors.primary3}
              style={{
                lineHeight: 1.5,
              }}
            >
              <span
                style={{
                  fontWeight: 500,
                }}
              >
                {termsPrefix}
              </span>{' '}
              {title}
            </Typo>
          </div>
        </div>
        <div
          className="min-w-[30px] cursor-pointer"
          onClick={() => {
            if (onTermsDetailClick) {
              onTermsDetailClick(terms);
            }
          }}
        >
          <ArrowRight />
        </div>
      </div>
    );
  };

  return (
    <div className="flex flex-col min-h-[200px] gap-[6px]">
      <div
        className="flex gap-1 items-start min-h-[40px]"
        onClick={() => {
          handleAllAgreementClick();
        }}
      >
        <div className="mr-2 grow-0">
          <Checkbox id={`all`} checked={allTermsAgreement} />
        </div>
        <div className="mt-[2px]">
          <Typo type="m-16">{strings.allTermsAgreement}</Typo>
        </div>
      </div>
      {termsList.map((terms) => {
        return renderTermsItem(terms);
      })}
    </div>
  );
}

export default TermsList;
